export default __webpack_public_path__ + "static/spark_main-a983bb5163e6ac562c8010392e5a56d4.png";